import React from 'react';
import {Dropdown, MenuItem, Glyphicon} from 'react-bootstrap';
import {injectIntl, intlShape} from 'react-intl';
import PropTypes from 'prop-types';

class MoveToBlockDropDown extends React.Component {

    constructor(props) {
        super(props);

    }

    render() {

        const {card, intl} = this.props;

        return (
            <Dropdown onClick={this.handleClick} pullRight={true} id="change-lane-dropdown">
                <Dropdown.Toggle noCaret={true}>
                    <Glyphicon glyph="share-alt"/>
                </Dropdown.Toggle>
                <Dropdown.Menu>
                    <MenuItem header>{intl.formatMessage({id: 'move_to_dropdown_header'})}</MenuItem>
                    {card.store.rootStore.blocks.map((block) => (
                        <MenuItem
                            key={block.id}
                            eventKey={block}
                            onClick={this.handleClick}
                            onSelect={this.handleSelect}
                            disabled={card.store.id === block.id}>
                            {intl.formatMessage({id: block.name})}
                        </MenuItem>
                    ))}
                </Dropdown.Menu>
            </Dropdown>
        );
    }

    handleSelect = (block, e) => {
        block.moveCardFromDropdown(this.props.card);
    };

    // Avoid the parent note listening to the click event
    handleClick(e) {
        e.stopPropagation();
    }

    // isMenuItemDisabled = (laneId) => {
    //     return this.props.note.listId === laneId;
    // };

}

export default injectIntl(MoveToBlockDropDown);

MoveToBlockDropDown.propTypes = {
    card: PropTypes.object.isRequired
};